import React from "react";
import {
  StateContext,
  StateDispatchContext,
  UPDATE_SEARCH,
  FILTER_LOCATIONS
} from "../State";

export function useDispatch() {
  const dispatch = React.useContext(StateDispatchContext);

  const updateSearch = (keyword) => dispatch({ type: UPDATE_SEARCH, keyword });
  const filterLocations = (activeFilter) => dispatch({ type: FILTER_LOCATIONS, activeFilter });

  return {
    updateSearch,
    filterLocations
  };
}

export function useViewState() {
  const state = React.useContext(StateContext);
  if (state === undefined) throw new Error('useState must be used within a StateProvider');

  return state.view;
}
